const REGISTER_DRAG_COMPONENT = 'REGISTER_DRAG_COMPONENT';
const UPDATE_DRAG_COMPONENT_POSITION = 'UPDATE_DRAG_COMPONENT_POSITION';
const UNREGISTER_DRAG_COMPONENT = 'UNREGISTER_DRAG_COMPONENT';

export {
  REGISTER_DRAG_COMPONENT,
  UPDATE_DRAG_COMPONENT_POSITION,
  UNREGISTER_DRAG_COMPONENT,
};
